export class LimitData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sizeLimit",
            "baseName": "sizeLimit",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "objectCountLimit",
            "baseName": "objectCountLimit",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "quotaLimit",
            "baseName": "quotaLimit",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return LimitData.attributeTypeMap;
    }
    constructor() {
    }
}
